import { Skeleton } from '@any-ui-react/core';

import { DashboardSection } from '../DashboardSection';

export const EmployeeDetailsLoader = () => (
  <div className="mt-6">
    <DashboardSection title="My Information">
      <div className="flex flex-col gap-4 lg:flex-row lg:gap-20">
        <div className="flex w-[260px] flex-col items-center justify-between gap-4 rounded-2xl border p-4">
          <Skeleton className="h-[144px] w-[144px] rounded-full" />

          <Skeleton className="h-7 w-full text-center text-lg font-semibold" />

          <div className="flex w-1/2 flex-col items-center space-y-1 text-center">
            <Skeleton className="h-7 w-full" />
            <Skeleton className="h-7 w-1/2" />
          </div>
        </div>

        <div className="flex w-full flex-1 flex-col gap-6">
          <Skeleton className="h-7 w-[220px]" />

          <div className="flex flex-col gap-5">
            {Array.from({ length: 6 }).map((_, index) => (
              <div key={index} className="flex items-center space-x-8">
                <Skeleton key={index} className="h-7 w-1/6" />
                <Skeleton className="h-7 w-1/3" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </DashboardSection>
  </div>
);
